import { bloborCopy } from '../../lib/strings/blobor';
import { useLocale } from '../../state/useLocale';
import { LinkButton } from '../../ui';

/**
 * The landing page's door to `/blobor` (owner, 2026-10-31: the showcase is
 * linked from the landing). One band in the landing's own frame (.band-head,
 * the pedigree's head), after the roster: the roster says who the course is
 * written by, this says what the method built.
 */
export function BloborBand() {
  const { locale } = useLocale();
  const s = bloborCopy[locale].band;
  return (
    <section className="blobor-band" aria-labelledby="blobor-band-title">
      <div className="band-head">
        <p className="label">{s.label}</p>
        <h2 className="h-band" id="blobor-band-title">{s.title}</h2>
        <p className="lede">{s.lede}</p>
      </div>
      <p className="blobor-band__link">
        <LinkButton href="/blobor">{s.link}</LinkButton>
      </p>
    </section>
  );
}

export default BloborBand;
